import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import axiosAdmin from 'utils/axiosAdmin';
import URL from 'config/url';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const getAdmins = createAsyncThunk('GET ADMIN', async (data, thunkAPI) => {
  const response = await axiosAdmin.get(
    `${URL.GET_ADMINS}?page=${data.page}&limit=${data.limit}&text=${data.text || ''}`,
    thunkAPI
  );
  return response.data;
});

export const getAdminDetails = createAsyncThunk('GET ADMIN DETAILS', async (data, thunkAPI) => {
  const response = await axiosAdmin.get(`${URL.GET_ADMINS}/${data?.id}`, thunkAPI);
  return response.data;
});

export const createAdmin = createAsyncThunk('CREATE ADMIN', async (data, thunkAPI) => {
  const response = await axiosAdmin.post(URL.CREATE_ADMIN, data, thunkAPI);
  return response.data;
});

export const updateAdminStatus = createAsyncThunk('UPDATE ADMIN STATUS', async (data, thunkAPI) => {
  const payload = {
    id: data.id,
    status: data.status ? 'ACTIVE' : 'INACTIVE',
  };
  const response = await axiosAdmin.patch(URL.ADMIN_STATUS, payload, thunkAPI);
  return response.data;
});

export const adminUserLogin = createAsyncThunk('ADMIN USER LOGIN', async (data, thunkAPI) => {
  const response = await axiosAdmin.post(URL.AGENCY_USER_LOGIN, data, thunkAPI);

  let domain = ['uat', 'qa', 'dev', 'dbdev', 'dbqa', 'dbuat'].includes(process.env.ENV_NAME)
    ? '.clubxeni.com'
    : '.xeni.com';

  if (response?.data?.status?.toLocaleLowerCase() === 'success') {
    cookies.set('x-access-token', response.data.data.token, {
      domain,
      path: '/',
      maxAge: 3600 * 24 * 7,
    });

    window.open(`${window.location.protocol}//${response.data.data.domain}`, '_blank');
  }
  return response.data;
});

export const editAdmin = createAsyncThunk('EDIT ADMIN', async (data, thunkAPI) => {
  const response = await axiosAdmin.patch(URL.EDIT_ADMIN, data, thunkAPI);
  return response.data;
});

export const deleteAdmin = createAsyncThunk('DELETE ADMIN', async (data, thunkAPI) => {
  const response = await axiosAdmin.delete(URL.DELETE_ADMIN, { id: data.id }, thunkAPI);
  return response.data;
});

export const getAdminRoles = createAsyncThunk('GET ADMIN ROLES', async (_, thunkAPI) => {
  const response = await axiosAdmin.get(URL.GET_ADMIN_ROLES, thunkAPI);
  return response.data;
});

const initialState = {
  isLoading: false,
  admin: null,
  adminSuccess: false,
  adminDetails: null,
  roles: [],
};

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {},
  extraReducers: {
    [getAdmins.pending]: (state) => {
      state.isLoading = true;
      state.adminDetails = null;
      state.adminSuccess = false;
    },
    [getAdmins.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.admin = action.payload.data;
    },
    [getAdmins.rejected]: (state, action) => {
      state.isLoading = false;
      state.admin = null;
      toast.error(action?.payload?.message);
    },

    [getAdminDetails.pending]: (state) => {
      state.isLoading = true;
      state.adminDetails = null;
    },
    [getAdminDetails.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.adminDetails = action.payload.data;
    },
    [getAdminDetails.rejected]: (state, action) => {
      state.isLoading = false;
      state.adminDetails = null;
      toast.error(action?.payload?.message);
    },

    [updateAdminStatus.pending]: (state) => {
      state.isLoading = true;
    },
    [updateAdminStatus.fulfilled]: (state, action) => {
      state.isLoading = false;
      toast.success(action?.payload?.message);
    },
    [updateAdminStatus.rejected]: (state, action) => {
      state.isLoading = false;
      toast.error(action?.payload?.message);
    },

    [createAdmin.pending]: (state) => {
      state.isLoading = true;
      state.adminSuccess = false;
    },
    [createAdmin.fulfilled]: (state, action) => {
      state.adminSuccess = true;
      state.isLoading = false;
      toast.success(action?.payload?.message);
    },
    [createAdmin.rejected]: (state, action) => {
      state.isLoading = false;
      state.adminSuccess = false;
      toast.error(action?.payload?.error || action?.payload?.message);
    },

    [editAdmin.pending]: (state) => {
      state.isLoading = true;
      state.adminSuccess = false;
    },
    [editAdmin.fulfilled]: (state, action) => {
      state.adminSuccess = true;
      state.isLoading = false;
      toast.success(action?.payload?.message);
    },
    [editAdmin.rejected]: (state, action) => {
      state.isLoading = false;
      state.adminSuccess = false;
      toast.error(action?.payload?.error || action?.payload?.message);
    },

    [deleteAdmin.pending]: (state) => {
      state.isLoading = true;
    },
    [deleteAdmin.fulfilled]: (state, action) => {
      state.isLoading = false;
      toast.success(action?.payload?.message);
    },
    [deleteAdmin.rejected]: (state, action) => {
      state.isLoading = false;
      toast.error(action?.payload?.message);
    },

    [getAdminRoles.fulfilled]: (state, action) => {
      state.roles = action.payload.data?.roles || [];
    },
    [getAdminRoles.rejected]: (state, action) => {
      state.roles = [];
      toast.error(action?.payload?.message);
    },
  },
});

export default adminSlice.reducer;
